(() => {
  if (customElements.get('sv-live-cart-reviews')) return;
  class StudiosVintageCartFeedback extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.load(this.controller.signal);
    }
    disconnectedCallback() { clearInterval(this.timer); this.controller?.abort(); this.controller = null; }
    sourceCards(root) {
      const source = root.querySelector('[data-sv-review-source]');
      if (!source) return [];
      const pass = source.querySelector('.ml-marquee-pass:not([aria-hidden="true"])');
      return [...(pass || source).querySelectorAll('.tp-card')];
    }
    async load(signal) {
      this.setAttribute('aria-busy', 'true');
      try {
        let cards = this.sourceCards(document);
        if (!cards.length && this.dataset.sourceUrl) {
          const url = new URL(this.dataset.sourceUrl, location.href);
          if (url.origin !== location.origin) return;
          const response = await fetch(url.href, {credentials: 'same-origin', signal});
          if (!response.ok) return;
          cards = this.sourceCards(new DOMParser().parseFromString(await response.text(), 'text/html'));
        }
        if (signal.aborted || !this.isConnected) return;
        const records = [], seen = new Set();
        for (const card of cards) {
          const identity = card.querySelector('.tp-card__name')?.cloneNode(true);
          const locationText = card.querySelector('.tp-card__city')?.textContent.replace(/^\s*\u00b7\s*/, '').trim() || '';
          identity?.querySelector('.tp-card__city')?.remove();
          const name = identity?.textContent.trim() || '';
          const text = card.querySelector('.tp-card__text')?.textContent.trim() || '';
          const photo = card.querySelector('.tp-card__photo[src]');
          const image = photo?.getAttribute('src') || '';
          const key = JSON.stringify([name, locationText, text, image]);
          if (!text || seen.has(key)) continue;
          seen.add(key);
          records.push({name, locationText, text, image, alt:photo?.getAttribute('alt') || '', sample:card.dataset.svReviewKind === 'sample'});
          if (records.length === 5) break;
        }
        if (!records.length) return;
        const widget = document.createElement('div'); widget.className = 'tpc';
        const star = '<span class="tpc__sq"><svg viewBox="0 0 24 24"><path d="M12 2l2.9 6.9 7.1.6-5.4 4.7 1.6 7L12 17.8 5.8 21.2l1.6-7L2 9.5l7.1-.6z"/></svg></span>';
        const stars = star.repeat(5);
        const isSample = records.some(r=>r.sample);
        { // Branding is independent of review authenticity and profile URL.
          const brand=document.createElement('div');brand.className='tpc__brand';brand.innerHTML='<svg viewBox="0 0 24 24"><path fill="#00b67a" d="M12 2l2.9 6.9 7.1.6-5.4 4.7 1.6 7L12 17.8 5.8 21.2l1.6-7L2 9.5l7.1-.6z"/></svg><b>Trustpilot</b>';widget.append(brand);
        }
        const rate=document.createElement('div');rate.className='tpc__rate';rate.innerHTML='<span class="tpc__stars">'+stars+'</span>';
        const score=document.createElement('span');score.className='tpc__scoretxt';score.textContent=this.dataset.rating||'';rate.append(score);widget.append(rate);
        const slider=document.createElement('div');slider.className='tpc__slider';
        const track=document.createElement('div');track.className='tpc__track';
        const dots=document.createElement('div');dots.className='tpc__dots';
        let index=0;const slides=[];const indicators=[];
        const show=n=>{index=(n+records.length)%records.length;slides.forEach((v,i)=>{v.classList.toggle('is-active',i===index);v.hidden=i!==index});indicators.forEach((v,i)=>v.classList.toggle('is-active',i===index));};
        const reset=()=>{clearInterval(this.timer);if(records.length>1)this.timer=setInterval(()=>show(index+1),4500);};
        const nav=(dir,label)=>{const btn=document.createElement('button');btn.className='tpc__nav';btn.type='button';btn.setAttribute('aria-label',label);btn.innerHTML='<svg viewBox="0 0 24 24"><path d="'+(dir<0?'M15 6l-6 6 6 6':'M9 6l6 6-6 6')+'"/></svg>';btn.addEventListener('click',()=>{show(index+dir);reset()},{signal});return btn;};
        records.forEach((record,n)=>{
          const slide=document.createElement('div');slide.className='tpc__rev';
          if(record.image){const url=new URL(record.image,location.href);if(['https:','http:'].includes(url.protocol)){const img=document.createElement('img');img.className='tpc__photo';img.src=url.href;img.alt=record.alt;img.loading='lazy';slide.append(img);}}
          const body=document.createElement('div');body.className='tpc__body';const mini=document.createElement('div');mini.className='mini';mini.innerHTML=stars;body.append(mini);
          const text=document.createElement('p');text.className='tpc__text';text.textContent=record.text;body.append(text);
          const who=document.createElement('span');who.className='tpc__who';const name=document.createElement('b');name.textContent=record.name;who.append(name,document.createTextNode(' · '+record.locationText));body.append(who);slide.append(body);track.append(slide);slides.push(slide);
          const dot=document.createElement('button');dot.type='button';dot.className='tpc__dot';dot.setAttribute('aria-label',(this.dataset.review||'Review')+' '+(n+1));dot.addEventListener('click',()=>{show(n);reset()},{signal});dots.append(dot);indicators.push(dot);
        });
        if(records.length>1)slider.append(nav(-1,this.dataset.previous));slider.append(track);if(records.length>1)slider.append(nav(1,this.dataset.next));widget.append(slider,dots);
        if(isSample){const note=document.createElement('p');note.className='tpc__sample';note.textContent=this.dataset.sample;widget.append(note);}
        widget.addEventListener('mouseenter',()=>clearInterval(this.timer),{signal});widget.addEventListener('mouseleave',reset,{signal});
        this.replaceChildren(widget);this.hidden=false;show(0);reset();
      } catch (error) {
        // Never block native cart actions or replace missing customer feedback with invented testimonials.
      } finally { if (!signal.aborted) this.removeAttribute('aria-busy'); }
    }
  }
  customElements.define('sv-live-cart-reviews', StudiosVintageCartFeedback);
})();
